import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Row, Col, Image, Dropdown, Button, Typography, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LogoDark } from 'assets/img/logo_dark.svg';
import authBg from 'assets/img/auth-bg.webp';
import dots from 'assets/img/dots.png';
import germany from 'assets/svg/germany.svg';
import unitesStates from 'assets/svg/united_states.svg';
import { DownOutlined } from '@ant-design/icons';

import {
  AuthWrapper,
  AuthSider,
  AuthContent,
  StyledCarousel,
  StyledCarouselItem,
  ImageWrapper,
  StyledCarouselContent,
  StyledLogo,
  StyledSwitcher
} from './styled';
import useIsMobile from 'hooks/useIsMobile';

const { Text } = Typography;

const Auth: FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isMobile = useIsMobile();

  const showLeftSider = !isMobile && location.pathname !== '/verify';

  const handleClickLang = (info: { key: string }) => {
    i18n.changeLanguage(info.key);
    localStorage.setItem('locale', info.key);
  };

  const LANGUAGES = [
    {
      key: 'en',
      label: (
        <Flex align="center" gap={8}>
          <Image src={unitesStates} preview={false} width={24} />
          <Text style={{ fontSize: 16 }}>English</Text>
        </Flex>
      )
    },
    {
      key: 'de',
      label: (
        <Flex align="center" gap={8}>
          <Image src={germany} preview={false} width={24} />
          <Text style={{ fontSize: 16 }}>Deutsch</Text>
        </Flex>
      )
    }
  ];

  const activeLang = LANGUAGES.find(item => item.key === i18n.language);

  return (
    <AuthWrapper leftSiderHidden={isMobile}>
      {showLeftSider && (
        <AuthSider>
          <StyledLogo>
            <LogoDark width={175} height={32} />
          </StyledLogo>
          <StyledCarousel>
            <StyledCarouselItem>
              <ImageWrapper image={authBg}>
                <StyledCarouselContent>
                  <Image src={dots} preview={false} width={58} />
                  <h3>{t('auth.unlock_the_future')}</h3>
                  <p>{t('auth.establish_productive')}</p>
                </StyledCarouselContent>
              </ImageWrapper>
            </StyledCarouselItem>
          </StyledCarousel>
        </AuthSider>
      )}
      <AuthContent leftSiderHidden={!showLeftSider}>
        <Row
          justify="center"
          style={
            showLeftSider
              ? {
                  height: '100vh',
                  overflowY: 'auto',
                  padding: '16px 0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }
              : {}
          }
        >
          <StyledSwitcher>
            <Dropdown
              menu={{ items: LANGUAGES, onClick: handleClickLang }}
              placement="bottom"
              trigger={['hover']}
            >
              <Button type="text" style={{ padding: 0, color: 'white' }}>
                {activeLang?.label}
                <DownOutlined />
              </Button>
            </Dropdown>
          </StyledSwitcher>
          <Col span={!showLeftSider ? 24 : 16}>
            {isMobile && <LogoDark style={{ marginBottom: 32 }} />}
            <Outlet />
          </Col>
        </Row>
      </AuthContent>
    </AuthWrapper>
  );
};

export default Auth;
